@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.legal {
    grid-column: 1 / span 2;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 1;
    }
}
